export const ENV = {
    LOCAL:      'local',
    DEV:        'development',
    SANDBOX:    'sandbox',
    PRODUCTION: 'production'
};
